import { createRouter, createWebHistory } from 'vue-router'
import Landing from '../views/Landing.vue'
import About from '../views/About.vue'
import Categories from '../views/Categories.vue'
import Judging from '../views/Judging.vue'
import Recipients from '../views/Recipients.vue'
import Timeline from '../views/Timeline.vue'

import NotFound from '../views/404.vue';


const routes = [
  { path: '/',component: Landing },
  { path: '/about',component: About },
  { path: '/categories',component: Categories },
  { path: '/judging',component: Judging },
  { path: '/recipients',component: Recipients },
  { path: '/Timeline',component: Timeline },
  
  
  { path: '/:pathMatch(.*)*', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
